webpackJsonp([34,39,42],{

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1014);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("34908a7f", content, true, {});

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".native .LinkButtons2 .link-buttons[data-v-06f5975c]{border-width:1px;border-style:none solid solid none}.native .LinkButtons2 .link-button[data-v-06f5975c]{border-width:1px;border-style:solid none none solid}.desktop .LinkButtons2 .link-buttons[data-v-06f5975c],.smartphone .LinkButtons2 .link-buttons[data-v-06f5975c],.tablet .LinkButtons2 .link-buttons[data-v-06f5975c]{border-width:1px;border-style:none solid solid none}.desktop .LinkButtons2 .link-button[data-v-06f5975c],.smartphone .LinkButtons2 .link-button[data-v-06f5975c],.tablet .LinkButtons2 .link-button[data-v-06f5975c]{border-width:1px;border-style:solid none none solid}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/LinkButtons2/LinkButtons2.vue"],"names":[],"mappings":"AAwDA,qDACI,iBAAkB,AAClB,kCAAoC,CACvC,AACD,oDACI,iBAAkB,AAClB,kCAAoC,CACvC,AA6DD,oKAGI,iBAAkB,AAClB,kCAAoC,CACvC,AACD,iKAGI,iBAAkB,AAClB,kCAAoC,CACvC","file":"LinkButtons2.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.native[data-v-06f5975c] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.native .LinkButtons2 .link-buttons[data-v-06f5975c] {\n    border-width: 1px;\n    border-style: none solid solid none;\n}\n.native .LinkButtons2 .link-button[data-v-06f5975c] {\n    border-width: 1px;\n    border-style: solid none none solid;\n}\n@media (min-width: 768px) {\n.native[data-v-06f5975c] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n}\n@media (min-width: 1025px) {\n.native[data-v-06f5975c] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n}\n.smartphone[data-v-06f5975c],\n.tablet[data-v-06f5975c],\n.desktop[data-v-06f5975c] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.smartphone .LinkButtons2 .link-buttons[data-v-06f5975c],\n  .tablet .LinkButtons2 .link-buttons[data-v-06f5975c],\n  .desktop .LinkButtons2 .link-buttons[data-v-06f5975c] {\n    border-width: 1px;\n    border-style: none solid solid none;\n}\n.smartphone .LinkButtons2 .link-button[data-v-06f5975c],\n  .tablet .LinkButtons2 .link-button[data-v-06f5975c],\n  .desktop .LinkButtons2 .link-button[data-v-06f5975c] {\n    border-width: 1px;\n    border-style: solid none none solid;\n}\n.tablet[data-v-06f5975c],\n.desktop[data-v-06f5975c] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.desktop[data-v-06f5975c] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./LinkButtons2.l.scss": 1016,
	"./LinkButtons2.m.scss": 1018,
	"./LinkButtons2.s.scss": 1020,
	"./LinkButtons2.scss": 1022
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1015;

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1017);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1019);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1021);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".LinkButtons2 .link-buttons{border-width:1px;border-style:none solid solid none}.LinkButtons2 .link-button{border-width:1px;border-style:solid none none solid}", ""]);

// exports


/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1023);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".LinkButtons2 .link-buttons{border-width:1px;border-style:none solid solid none}.LinkButtons2 .link-button{border-width:1px;border-style:solid none none solid}", ""]);

// exports


/***/ }),

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contents)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.isEditing}}},[_c('section',{class:_vm.sectionClassArray,style:(_vm.sectionStyle)},[_c('div',{class:_vm.containerClassArray},[(_vm.contents.items.length)?[_c('div',{class:[this.gridClassArray, 'link-buttons', 'theme-accent-border-color']},[_vm._l((_vm.contents.items),function(item,index){return [(item.pageId)?[_c('div',[_c('a',{staticClass:"link-button theme-accent-border-color theme-accent-bg-color-hover p2 block fit-width text-center bold"},[_c('i',{class:['block', 'fa', ' fa-' + item.icon],attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.getPageById(item.pageId).title.rendered))])])]:[_c('div',[_c('a',{staticClass:"link-button theme-accent-border-color theme-accent-bg-color-hover p2 block fit-width text-center bold"},[_vm._v("ページを選択してください")])])]]})],2)]:[_vm._m(0)]],2)])])]),_vm._v(" "),_c('el-form',{class:['component-contents-form', ' p2', _vm.lock ? 'hide' : _vm.isEditing ? 'show' : 'hide'],attrs:{"model":_vm.contents}},[_c('h2',[_vm._v("コンポーネントのコンテンツを編集")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"コンポーネント配置順序","label-width":"170px"}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":_vm.positionMax},model:{value:(_vm.newPosition),callback:function ($$v) {_vm.newPosition=$$v},expression:"newPosition"}}),_c('span',{staticClass:"pl4"},[_vm._v("1から"+_vm._s(_vm.positionMax)+"まで")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内部リンク","label-width":_vm.labelWidth}},[_vm._l((_vm.contents.items),function(item,index){return [_c('div',{staticClass:"flex"},[_c('el-select',{staticClass:"width-20",staticStyle:{"display":"inline-block"},attrs:{"placeholder":"アイコンリストから選択"},model:{value:(_vm.contents.items[index].icon),callback:function ($$v) {_vm.$set(_vm.contents.items[index], "icon", $$v)},expression:"contents.items[index].icon"}},_vm._l((_vm.icons),function(icon){return _c('el-option',{key:icon.value,staticClass:"el-opp",attrs:{"label":icon.label,"value":icon.value}},[_c('span',{staticStyle:{"display":"inline-block","width":"2em"}},[_c('i',{class:['fa', ' fa-' + icon.value],staticStyle:{"font-size":"1.5em"},attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(icon.value))])])})),_vm._v(" "),_c('el-select',{staticClass:"width-50 ml1",staticStyle:{"display":"inline-block"},attrs:{"value-key":"link","placeholder":"固定ページから選択"},model:{value:(_vm.contents.items[index].pageId),callback:function ($$v) {_vm.$set(_vm.contents.items[index], "pageId", $$v)},expression:"contents.items[index].pageId"}},_vm._l((_vm.publishedPages),function(page){return _c('el-option',{key:page.link,staticClass:"el-opp",attrs:{"label":page.title.rendered,"value":page.id}})})),_vm._v(" "),_c('el-button',{staticClass:"width-20 ml1",on:{"click":function($event){_vm.onDeleteLink(index)}}},[_vm._v("リンクの削除")])],1)]}),_vm._v(" "),_c('el-button',{staticClass:"my1",on:{"click":_vm.onAddLink}},[_vm._v("リンクボタンの追加")])],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スマホサイズで横に並べるリンクボタンの数","label-width":_vm.labelWidth}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":2},model:{value:(_vm.contents.layout.s),callback:function ($$v) {_vm.$set(_vm.contents.layout, "s", $$v)},expression:"contents.layout.s"}}),_c('span',{staticClass:"pl4"},[_vm._v("最大2まで")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"タブレットサイズで横に並べるリンクボタンの数","label-width":_vm.labelWidth}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":4},model:{value:(_vm.contents.layout.m),callback:function ($$v) {_vm.$set(_vm.contents.layout, "m", $$v)},expression:"contents.layout.m"}}),_c('span',{staticClass:"pl4"},[_vm._v("最大4まで")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"デスクトップサイズで横に並べるリンクボタンの数","label-width":_vm.labelWidth}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":6},model:{value:(_vm.contents.layout.l),callback:function ($$v) {_vm.$set(_vm.contents.layout, "l", $$v)},expression:"contents.layout.l"}}),_c('span',{staticClass:"pl4"},[_vm._v("最大6まで")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド上下の余白","label-width":_vm.labelWidth}},[_c('el-slider',{attrs:{"step":1,"min":0,"max":10},model:{value:(_vm.contents.padding.y),callback:function ($$v) {_vm.$set(_vm.contents.padding, "y", $$v)},expression:"contents.padding.y"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.bg.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.bg, "isCustom", $$v)},expression:"contents.bg.isCustom"}},[_vm._v("スライドの背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.bg.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.bg.color),callback:function ($$v) {_vm.$set(_vm.contents.bg, "color", $$v)},expression:"contents.bg.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.bg.color))])],1)]),_vm._v(" "),_c('div',{staticClass:"component-contents-controller flex justify-end items-center"},[_c('component-form-footer',{on:{"delete":function($event){_vm.deleteComponent()},"cancel":function($event){_vm.isEditing = false},"update":function($event){_vm.updateComponent()}}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-warning flex justify-center items-center"},[_c('span',{staticClass:"component-warning-span"},[_vm._v("リンクを追加してください")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkButtons2_vue__ = __webpack_require__(807);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f5975c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkButtons2_vue__ = __webpack_require__(1024);
function injectStyle (ssrContext) {
  __webpack_require__(1013)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06f5975c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkButtons2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f5975c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkButtons2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'link-buttons-2',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__["default"]],
  data: function data() {
    return {
      labelWidth: '20em',
      icons: Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* getFontawesomeIcons */])()
    };
  },
  methods: {
    onAddLink: function onAddLink() {
      this.contents.items.push({
        icon: 'car',
        pageId: null,
        color: ''
      });
    },
    onDeleteLink: function onDeleteLink(index) {
      this.contents.items.splice(index, 1);
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var _this = this;

      var linkButtons = contents.items.reduce(function (acc, item) {
        var blank = item.blank ? 'target="_blank"' : '';
        return acc + ('<div><a class="link-button theme-accent-border-color theme-accent-bg-color-hover p2 block fit-width text-center bold page-id-' + _this.getPageById(item.pageId).id + '" href="' + _this.getPageById(item.pageId).link + '" ' + blank + '><i class="block fa fa-' + item.icon + '" aria-hidden="true"></i>' + _this.getPageById(item.pageId).title.rendered + '</a></div>');
      }, '');

      return ('\n      <section id="' + this.sectionId + '" class="' + this.sectionClass + '">\n        <div class="' + this.containerClass + '">\n          <div class="' + this.gridClass + ' link-buttons theme-accent-border-color">\n            ' + linkButtons + '\n          </div>\n        </div>\n      </section>').trim().replace(/>\s+</g, '><');
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var _this2 = this;

      var layout = __webpack_require__(1015)("./" + this.meta.file + '.scss');
      var theme = contents.bg.isCustom ? '.' + this.meta.file + '-' + this._uid + '-bg{background-color:' + contents.bg.color + '}' : '';
      theme = contents.items.reduce(function (acc, item) {
        return acc + ('body.page-id-' + _this2.getPageById(item.pageId).id + ' .' + _this2.meta.file + '-' + _this2._uid + ' .link-button.page-id-' + _this2.getPageById(item.pageId).id + ' {color: #fff; ' + _this2.getThemeInlineStyle('background-color', 'accent') + '}');
      }, theme);
      return { layout: layout, theme: theme };
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/34.6a7e8bb503ab378ce4fa.js